// see user.rb and RECURLY_STATUS_ACTIVE, RECURLY_STATUS_EXPIRED, RECURLY_STATUS_CANCELED, RECURLY_STATUS_PAST_DUE
enum RecurlyAccountStatus {
  Active = 'A',
  Cancelled = 'C',
  Expired = 'E',
  PastDue = 'P'
}

export default RecurlyAccountStatus;
